import React from 'react'
import classes from "./Dna.module.css"
import Fade from 'react-reveal/Fade';
import A from "./../../Assest/dbd.jpeg"
import B from "./../../Assest/rushi.jpeg"


const Dna = () => {
  return (
<div>

  <h2 className={classes.ih4d}>
<br/><br/>
About Our Founder – Rushikesh Bansode
<br/><br/>
</h2>


<div className={classes.steps2}>



 <Fade right>
<div className={classes.s2}>

<img src={B} className={classes.imd2} />
    
    </div>

      <Fade leftt>

<div className={classes.s1d}> 

<div className={classes.s123}> 
  <h3 className={classes.ih4}>
    Rushikesh Bansode is the visionary founder of RCG (Rushikesh Career Guidance), driven by a strong commitment to empowering students with clarity, confidence, and the right direction for academic and professional success. With a deep understanding of the challenges students and parents face during crucial career decisions, he established RCG to provide ethical, transparent, and personalized career guidance.
<br/><br/>
Rushikesh brings a thoughtful blend of educational insight, mentoring experience, and a student-first approach to career counselling. He strongly believes that every student deserves accurate guidance and compassionate support, while every parent deserves trust and transparency in the counselling process. Under his leadership, RCG delivers structured guidance, admission support, and long-term career planning that helps families make informed decisions with confidence.
<br/><br/>
His dedication to quality, integrity, and student success continues to shape RCG as a trusted partner for students and parents seeking reliable career guidance and meaningful academic outcomes.
  </h3>
 
</div>





</div>
</Fade>

</Fade>


</div>


    <div className={classes.bbd}>

  <h2 className={classes.ih4d}>
<br/><br/>
Foundation of Our Principles
<br/><br/>
</h2>


</div>

 
<div className={classes.steps}>
  <Fade leftt>

<div className={classes.s1}> 

<div className={classes.s11}> 
  <h3 className={classes.ih4}>Excellence in Career Guidance </h3>
  <p className={classes.ih41}>We strive to deliver accurate, reliable, and result-oriented career guidance that empowers students to make informed academic and professional decisions. </p>
</div>


<div className={classes.s11}> 
  <h3 className={classes.ih4}>Student-Centric Approach</h3>
  <p className={classes.ih41}>We continuously adopt modern counselling methods, assessment tools, and industry insights to help students discover the right path aligned with their strengths and aspirations. </p>
</div>


<div className={classes.s11}> 
  <h3 className={classes.ih4}>Distinct Career Direction</h3>
  <p className={classes.ih41}>By combining expert mentorship with up-to-date education trends, we create a unique guidance experience that sets RCG apart in shaping successful careers. </p>
</div>


<div className={classes.s11}> 
  <h3 className={classes.ih4}>Commitment to Trust & Quality</h3>
  <p className={classes.ih41}>Our guidance is built on transparency, ethical counselling, and high standards of service, ensuring confidence and long-term satisfaction for students and parents. </p>
</div>


<div className={classes.s11}> 
  <h3 className={classes.ih4}>Smooth & Supportive Journey</h3>
  <p className={classes.ih41}>Our well-structured processes support students at every stage — from career exploration to admissions — ensuring clarity, confidence, and timely assistance. </p>
</div>



</div>
</Fade>


 <Fade right>
<div className={classes.s2}>

<img src={A} className={classes.imd} />
    
    </div>

</Fade>


</div>



    </div>
  )
}

export default Dna